module.exports = "/_next/static/images/more_slack-integration-c84328c281ba3b14402f063caf2630ca.jpg";